// extracted by mini-css-extract-plugin
export default {"langSelect":"languagebar_langSelect__7San6","langOption":"languagebar_langOption__pXoAA","flagImg":"languagebar_flagImg__P1HXy"};